<template>
  <b-modal id="modal-migrar-lista" dialog-class="modal-conta" hide-footer :no-enforce-focus="true" centered>
    <template slot="modal-header">
      <h5 class="modal-title">Migrar progresso de usuários</h5>
      <button type="button" class="close" aria-label="Close" @click="$bvModal.hide('modal-migrar-lista')">
        <span aria-hidden="true">&times;</span>
      </button>
    </template>

    <div class="row">
      <div class="col-12 col-md">
        <a :href="baseFile" download>Download arquivo template</a></div>
    </div>

    <div class="form-group mt-4 mb-2">
      <label class="mb-3">Exemplo (atentar aos módulos separados por ponto-e-vírgula, se não preencher a ordem dos módulos, irá migrar o progresso do curso todo)</label>
      <div class="table-responsive">
        <table class="table">
          <tr>
            <th>email</th>
            <th>curso_id (código do curso)</th>
            <th>modulos (ordem dos módulos)</th>
          </tr>
          <tr>
            <td>teste@jaleko.com.br</td>
            <td>167</td>
            <td>1;2;3</td>
          </tr>
        </table>
      </div>
    </div>

    <div class="form-group mt-4 mb-2">
      <label for="importar-lista" class="sr-only">Exemplo</label>
      <input type="file" class="form-control-file" id="importar-lista" ref="file" v-on:change="handleFileUpload">
    </div>

    <div class="text-center">
      <div class="d-flex align-items-center justify-content-center mt-5 mb-4">
        <a href="javascript:void(0)" class="btn btn-primary mr-3" @click="importarUsuarios">Importar</a>
        <a href="javascript:void(0)" class="btn btn-secondary" @click="$bvModal.hide('modal-migrar-lista')">Cancelar</a>
      </div>
    </div>
  </b-modal>
</template>

<script>
import UsuarioAPI from '@/api/usuario-api'
import UrlUtils from '@/core/util/url-utils'
import Swal from 'sweetalert2'

export default {
  name: 'ModalMigracaoProgressoUsuarios',
  data () {
    return {
      file: null,
      baseFile: UrlUtils.obterUrlS3('modelo_importacao/import_progresso_template.csv')
    }
  },

  mounted () {
    this.$root.$on('bv::modal::show', () => {
      this.file = null
    })
  },

  methods: {
    show: function () {
      this.$bvModal.show('modal-migrar-lista')
    },

    handleFileUpload: function () {
      this.file = this.$refs.file.files[0]
    },

    importarUsuarios: function () {
      if (!this.file) {
        Swal.fire({
          icon: 'error',
          text: 'Obrigatório informar o arquivo para importação'
        })
        return
      }

      UsuarioAPI.migrarProgressoUsuarios(this.file)

      Swal.fire({
        title: '<i class="far fa-hourglass"></i>',
        html: 'Migração do progresso de usuários em andamento<br><a href="/conta/migracao/resultado" class="btn btn-primary mt-3" target="_blank">Acompanhar</a>',
        showConfirmButton: false,
        showCloseButton: true
      })
    }
  }
}
</script>

<style scoped>

</style>
